import { useAuth } from '../contexts/AuthContext';
import AdminDashboard from './AdminDashboard';
import FinancialFlash from '../components/FinancialFlash';

export default function Dashboard() {
  const { user } = useAuth();

  if (user?.role === 'admin') return <AdminDashboard />;

  return <FinancialFlash />;
}
